import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import {environment} from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class OpenViduService {
    OPENVIDU_SERVER_URL = environment.openviduServerUrl || 'https://localhost:4443';
    MY_SECRET = environment.openviduSecret || 'MY_SECRET';
    ANDROID_PERMISSIONS = [
        'android.permission.CAMERA',
        'android.permission.RECORD_AUDIO',
        'android.permission.MODIFY_AUDIO_SETTINGS',
        'android.permission.BLUETOOTH',
        'android.permission.BLUETOOTH_ADMIN'
    ];

    private audioDeviceId: any = null;
    private videoDeviceId: any = null;

    public sessionId: string;

    constructor(private http: HttpClient, private androidPermissions: AndroidPermissions) {}

    getToken(mySessionId: string): Promise<string> {
        return this.createSession(mySessionId, this.OPENVIDU_SERVER_URL, this.MY_SECRET).then((sessionId: string) => {
            this.sessionId = sessionId;
            return this.createToken(sessionId, this.OPENVIDU_SERVER_URL, this.MY_SECRET);
        });
    }

    createSession(sessionId: string, openviduServerUrl: string, openviduSecret: string) {
        return new Promise((resolve, reject) => {
            const body = JSON.stringify({ customSessionId: sessionId, recordingMode: "MANUAL" });
            const options = {
                headers: new HttpHeaders({
                    Authorization: 'Basic ' + btoa('OPENVIDUAPP:' + openviduSecret),
                    'Content-Type': 'application/json',
                }),
            };
            return this.http
                .post<any>(openviduServerUrl + '/openvidu/api/sessions', body, options)
                .pipe(
                    catchError((error) => {
                        error.status === 409 ? resolve(sessionId) : reject(error);
                        return observableThrowError(error);
                    }),
                )
                .subscribe((response) => {
                    console.log(response);
                    resolve(response.id);
                });
        });
    }

    startSessionRecodrings() {
        return new Promise((resolve, reject) => {
            const body = JSON.stringify({ session: this.sessionId, recordingMode: "MANUAL" });
            const options = {
                headers: new HttpHeaders({
                    Authorization: 'Basic ' + btoa('OPENVIDUAPP:' + this.MY_SECRET),
                    'Content-Type': 'application/json',
                }),
            };
            return this.http
                .post<any>(this.OPENVIDU_SERVER_URL + '/openvidu/api/recordings/start', body, options)
                .pipe(
                    catchError((error) => {
                        error.status === 409 ? resolve(this.sessionId) : reject(error);
                        return observableThrowError(error);
                    }),
                )
                .subscribe((response) => {
                    console.log(response);
                    resolve(response);
                });
        });
    }

    stopSessionRecodrings(recordingId) {
        return new Promise((resolve, reject) => {
            const options = {
                headers: new HttpHeaders({
                    Authorization: 'Basic ' + btoa('OPENVIDUAPP:' + this.MY_SECRET),
                    'Content-Type': 'application/json',
                }),
            };
            return this.http
                .post<any>(this.OPENVIDU_SERVER_URL + '/openvidu/api/recordings/stop/'+recordingId, {}, options)
                .pipe(
                    catchError((error) => {
                        error.status === 409 ? resolve(this.sessionId) : reject(error);
                        return observableThrowError(error);
                    }),
                )
                .subscribe((response) => {
                    console.log(response);
                    resolve(response);
                });
        });
    }

    createToken(sessionId: string, openviduServerUrl: string, openviduSecret: string): Promise<string> {
        return new Promise((resolve, reject) => {
            const body = JSON.stringify({});
            const options = {
                headers: new HttpHeaders({
                    Authorization: 'Basic ' + btoa('OPENVIDUAPP:' + openviduSecret),
                    'Content-Type': 'application/json',
                }),
            };
            return this.http
                .post<any>(openviduServerUrl + '/openvidu/api/sessions/' + sessionId + '/connection', body, options)
                .pipe(
                    catchError((error) => {
                        reject(error);
                        return observableThrowError(error);
                    }),
                )
                .subscribe((response) => {
                    console.log(response);
                    resolve(response.token);
                });
        });
    }

    getRandomAvatar(): string {
        return 'https://openvidu.io/img/logos/openvidu_globe_bg_transp_cropped.png';
    }

    checkAndroidPermissions(): Promise<void> {
        console.log('Requesting Android Permissions');
        return new Promise((resolve, reject) => {
            this.androidPermissions.requestPermissions(this.ANDROID_PERMISSIONS)
                .then(() => {
                  const promisesArray: Promise<any> [] = [];
                  this.ANDROID_PERMISSIONS.forEach((permission) => {
                    console.log('Checking ', permission);
                    promisesArray.push(this.androidPermissions.checkPermission(permission));
                  });
                  Promise.all(promisesArray).then((responses) => {
                    let allHasPermissions = true;
                    responses.forEach((response, i) => {
                        allHasPermissions =  response.hasPermission;
                        if (!allHasPermissions) {
                          reject(
                            new Error(
                              'Permissions denied: ' + this.ANDROID_PERMISSIONS[i]
                            ));
                        }
                    });
                    resolve();
                  }).catch((err) => { console.log(err); });
                })
                .catch((err) => console.error('Error requesting permissions: ', err));
        });
    }

    getAudioDeviceId() {
        if (this.audioDeviceId === null) {
            this.audioDeviceId = localStorage.getItem('audioDeviceId');
        }
        return this.audioDeviceId;
    }

    setAudioDeviceId(deviceId: string) {
        if (deviceId === null) {
            this.audioDeviceId = null;
            localStorage.removeItem('audioDeviceId');
        } else {
            this.audioDeviceId = deviceId;
            localStorage.setItem('audioDeviceId', deviceId);
        }
    }

    getVideoDeviceId() {
        if (this.videoDeviceId === null) {
            this.videoDeviceId = localStorage.getItem('videoDeviceId');
        }
        return this.videoDeviceId;
    }

    setVideoDeviceId(deviceId: string) {
        if (deviceId === null) {
            this.videoDeviceId = null;
            localStorage.removeItem('videoDeviceId');
        } else {
            this.videoDeviceId = deviceId;
            localStorage.setItem('videoDeviceId', deviceId);
        }
    }

}

